module.exports = __webpack_public_path__ + "static/walkieImage@2x-68f8bb01f0276f0b487223c75c9d7f0d.png";